export enum TransactionsTableSortColumn {
    Date,
    Description,
    Name,
    Amount,
    Bank,
}
